module.exports = __webpack_public_path__ + "static/media/an-post.a60e7543.svg";